<script setup lang="ts">
import { ref, watch } from 'vue'
import { globalStore } from '../stores/global'

const global = globalStore()

const props = defineProps({
  isShow: {
    type: Boolean,
    default: false
  }
})

</script>

<template>
  <div class="loading-component" v-if="isShow">
    <i class="icon"></i>
  </div>
</template>

<style scoped lang="less">
.loading-component{
  position: fixed;
  width: 100%;
  height: 100vh;
  left: 0;
  top: 0;
  background: rgba(0,0,0,0.3);
  z-index: 9999;
  .icon{
    width: 45px;
    height: 45px;
    background: url('@/assets/images/loading.gif') no-repeat center center;
    background-size: cover;
    position: absolute;
    display: block;
    left: 50%;
    margin-left: -22.5px;
    top: 50%;
    margin-top: -22.5px;
  }
}
</style>
